import type { Middleware } from '@nuxt/types';

const setAfterSignupPath: Middleware = ({
  route: {
    query: { after_signup_path: afterSignupPath },
  },
  app: { $cookies, $sentryUtils },
}) => {
  if (!afterSignupPath) {
    return;
  }

  try {
    $cookies.set('afterSignupPath', afterSignupPath, { maxAge: 60 * 60 * 24, path: '/' }); // 1 day
  } catch (e) {
    $sentryUtils.error(new Error(`Invalid afterSignupPath: ${afterSignupPath}`));
  }
};

export default setAfterSignupPath;
